<template>
    <i18n :path="`parental-controls.${mode}.signup.guide`" tag="div" class="parental-signup-guide">
        <template v-slot:loginLink>
            <br />
            <b
                ><router-link :to="{ name: loginRouteName }" :data-cy="`${mode}-login-link`">{{
                    $t('parental-controls.login-link')
                }}</router-link></b
            >
        </template>
    </i18n>
</template>

<script>
export default {
    name: 'ParentalSignupGuide',
    props: {
        mode: {
            type: String,
            required: true,
        },
    },
    computed: {
        loginRouteName() {
            if (this.mode === 'parent') return 'parent-login';
            else return 'add-child-login';
        },
    },
};
</script>

<style lang="less" scoped>
.parental-signup-guide {
    padding: 10px;
    background-color: #d7d7d7;
    font-size: 13px;
    line-height: 15px;
    text-align: center;
    color: black;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

    a {
        color: inherit;
        text-decoration: underline;
    }
}
</style>
